export const dataa = [
    {
      id: 1,
      branchCode: "0102",
      customerName: "Johnson",
      departmentCode: "0102",
      receiptNo: "0102",
      receiptDate: "10/10/2023",
      paymentType: "Cash",
      amount: "5000",
      action: "Action",
      ewt:"hgd"
    
    },
      {
        id: 2,
        branchCode: "0102",
        customerName: "Johnson",
        departmentCode: "0102",
        receiptNo: "0102",
        receiptDate: "10/10/2023",
        paymentType: "Cash",
        amount: "5000",
        action: "Action",
        ewt:"hgd"
      },
        {
          id: 3,
          branchCode: "0102",
          customerName: "Johnson",
          departmentCode: "0102",
          receiptNo: "0102",
          receiptDate: "10/10/2023",
          paymentType: "Cash",
          amount: "5000",
          action: "Action",
          ewt:"hgd"
        },
        {
          id: 4,
          branchCode: "0102",
          customerName: "Johnson",
          departmentCode: "0102",
          receiptNo: "0102",
          receiptDate: "10/10/2023",
          paymentType: "Cash",
          amount: "5000",
          action: "Action",
          ewt:"hgd"
        },
        {
          id: 5,
          branchCode: "0102",
          customerName: "Johnson",
          departmentCode: "0102",
          receiptNo: "0102",
          receiptDate: "10/10/2023",
          paymentType: "Cash",
          amount: "5000",
          action: "Action",
          ewt:"hgd"
        },
       {
          id: 6,
          branchCode: "0102",
          customerName: "Johnson",
          departmentCode: "0102",
          receiptNo: "0102",
          receiptDate: "10/10/2023",
          paymentType: "Cash",
          amount: "5000",
          action: "Action",
          ewt:"hgd"
        },
     
    ];
    